import {common_utils} from "../common/common_utils";
import {slots_tool} from "./slots_tool";
import {game_5007} from "./game_5007";
import {game_5013} from "./game_5013";

function game_5007_5013()
{

}
game_5007_5013.readDataValue = function(this1,data){
    this1.hasextra = false
    this1.hasfree = true
    this1.hasbonuswin = false
    this1.mapList = []

    var rows = 3
    this1.isfree = common_utils.isFreeTip(data)

    var mapJson = JSON.parse(data.detail.mapData)
    this1.scatterwin = data.detail.winFreeGameTimes
    common_utils.readDataValue(this1,data);
    this1.mapIndex = []
    this1.mapListDetail = []

      let odd_map = null;
      if(data.gameId === 5007)
      {
         odd_map = game_5007.odd_map;
      }
      else if(data.gameId === 5013)
      {
        odd_map = game_5013.odd_map;
      }

    for(var key = 0; key < mapJson.data.length; key++)
    {
      var mapTmp = []
      for (var j = 0; j < rows; j++) {
        for (var i = 0; i < 5; i++) {
          mapTmp.push(mapJson.data[key].map[i][j])
        }
      }
      this1.mapList.push(mapTmp)
      var winListDic = {}
      var mapIndexTmp = []
      for (var index = 0; index < mapJson.data[key].list.length; index++)
      {
        var line = true;
        let win_data = mapJson.data[key].list[index]
        for(var subIndex = 0; subIndex < 5; subIndex++)
        {
          var showindex = win_data.l[subIndex] * 5 + subIndex;
          var item = mapTmp[showindex];

          if ((item != win_data.s) && (item != "W"))
          {
              line = false
          }
          if (line)
          {
            mapIndexTmp.push(showindex)
          }
        }
        slots_tool.read_win_data(winListDic,win_data)
      }
      this1.mapIndex.push(mapIndexTmp)
      this1.mapListDetail.push(winListDic)
    }

    let winValueList = [];
    slots_tool.setWinValue(winValueList,this1.mapListDetail,odd_map,0);
    this1.winValueTotal = slots_tool.TotalValueByData(winValueList,data,20,this1.extra)

    this1.$nextTick(() => {
      this1.$nextTick(() => {
        this1.$nextTick(() => {
          this1.clearLines();
            setTimeout(() => {
              this1.clearLines();
              for(let key = 0; key < mapJson.data.length; key++) {
                for (let index = 0; index < mapJson.data[key].list.length; index++) {
                  for(let subIndex = 0; subIndex < 4; subIndex++) {
                    let fromIndex = mapJson.data[key].list[index].l[subIndex] * 5 + subIndex;
                    let toIndex = mapJson.data[key].list[index].l[subIndex + 1] * 5 + subIndex + 1;
                    slots_tool.drawLines(slots_tool.setMapsLineIdName("s",key,fromIndex), slots_tool.setMapsLineIdName("s",key,toIndex), index)
                  }
                }
              }
            }, 1000);
          })
        })
      })
}
export {
  game_5007_5013
};



// WEBPACK FOOTER //
// ./src/components/slots/game_5007_5013.js